import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
const DIGITS_CONTAINER_CSS = css `
  display: inline-flex;
  flex-direction: row;
  font-family: BoldTriplejackFont;
`;
const DIGIT_CSS = css `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;
const INVISIBLE_DIGIT_CSS = css `
  opacity: 0;
`;
export const CountdownTimerFixedWidthText = ({ timerStr, digitWidth }) => {
    const fixedWidthDigitContainerCss = useMemo(() => css `
      position: relative;
      width: ${digitWidth}px;
      max-width: ${digitWidth}px;
      min-width: ${digitWidth}px;
    `, [digitWidth]);
    return (_jsx("div", { css: DIGITS_CONTAINER_CSS, children: timerStr.split('').map((char, i) => (_jsxs("span", { css: fixedWidthDigitContainerCss, children: [_jsx("div", { css: DIGIT_CSS, children: char }), _jsx("div", { css: INVISIBLE_DIGIT_CSS, children: char })] }, i))) }));
};
